import React, { Fragment } from 'react';
import {
    Button,
    Checkbox,
    Form, Grid,
    GridColumn,
    Header,
    Icon, Label,
    Loader,
    Popup,
    Responsive,
    Segment, Select,
    Tab,
    Table,
    Input,
    Message,
} from 'semantic-ui-react';
import _ from 'lodash'
import axios from 'axios';
import { Redirect } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { toast, ToastContainer } from 'react-toastify';

import { FiltersOnStyle, HeaderCursor, IconHeader } from './css';
import Filters from './Filters';

import ResultsPerPageDropdown from '../../Assets/util/ResultsPerPageDropdown';
import PaginationSegment from '../../Assets/util/PaginationSegment';
import { DEFAULT_NUMBER_OF_ITEMS_PER_PAGE } from '../../Assets/util/util';
import PaginationFront from '../../util/PaginationFront';
import SearchTableData from '../../util/SearchTableData';
import * as XLSX from 'xlsx';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

// axios.defaults.crossDomain = true;

const NoCurrentGradesMessage = () => <p><FormattedMessage id="professorInputGrades.CurrentGradesMessage" /></p>;
const NoCurrentGradesFilterMessage = () => <p><FormattedMessage id="professorInputGrades.CurrentGradesFilterMessage" /></p>;

export default class StudentsWithoutGrades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [...this.props.data],
            allUngradedStudents: [],
            results: [],
            selectedData: [],
            grade: 8,
            groupGrade: '',
            clearData: [...this.props.data],

            showFiltersOnButton: false,
            showNoGradesFilterMode: false,
            showGradesMode: false,
            grading: false,

            showStudentInfo: false,
            studentId: '',
            sspId: '',
            studyProgramId: '',

            page: 0,
            postsPerPage: JSON.parse(localStorage.getItem('postsPerPageTab0')),
            activePage: 1,

            loading: false,
            loadGrading: false,
            activeIndex: 0,

            resetValue: false,
            //front filter properties
            filterDataMode: false,

            importedData: [],
            importErrors: [],
            showAllErrors: false,

            activeImportPage: 1,
            importPostsPerPage: 10,
            submittingGrades: false,

            importedSearchResults: [],
            importFilterGrade: '',
            importFilterStudyType: '',
            importFilterDepartmentId: '',
            importFilterStudyProgramBasicId: '',

        };

        this.handleGradeChange = this.handleGradeChange.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.confirmGrade = this.confirmGrade.bind(this);
        this.cancel = this.cancel.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.onSelectRow = this.onSelectRow.bind(this);
        this.handleResultsPerPageChange = this.handleResultsPerPageChange.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.groupGrading = this.groupGrading.bind(this);
        this.getResults = this.getResults.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmitImportedGrades = this.handleSubmitImportedGrades.bind(this);
        this.handleFileUpload = this.handleFileUpload.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handlePaginationChange = this.handlePaginationChange.bind(this);
        this.resetFileInput = this.resetFileInput.bind(this);
        this.getImportedResults = this.getImportedResults.bind(this);
        this.handleImportPaginationChange = this.handleImportPaginationChange.bind(this);
        this.handleResultsPerPageChangeImport = this.handleResultsPerPageChangeImport.bind(this);
        this.fileInputRef = React.createRef();

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.data !== this.props.data) {
            let { departmentId, studyProgramBasicId, studyType, sortingOption } = this.state;
            this.props.frontFilterData(this.props.data, departmentId, studyProgramBasicId, studyType ? studyType.id : null, sortingOption, false)
            this.setState({
                data: this.props.data,
                results: [],
            }, () => {
                this.setState({ grading: false, rowLoader: false, showGradesMode: null, grade: 8 });
            })
        }
    }

    getDataToRender() {

        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        if (this.state.activeIndex === 1) {
            return this.props.allUngradedStudents;
        }
        if (this.state.filterDataMode) {
            return this.props.filterData;
        }

        return this.state.data;
    }

    resetFileInput = () => {
        this.fileInputRef.value = '';
    };

    handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (evt) => {
            const data = new Uint8Array(evt.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const rows = XLSX.utils.sheet_to_json(sheet);

            const errors = [];
            const imported = [];

            const normalize = str => (str ? str.toString().trim().toLowerCase().replace(/\s+/g, ' ') : '');

            if (this.getDataToRender().length === 0) {
                //console.error('No students available in getDataToRender!');
                //return;
            }

            rows.forEach((row, i) => {
                const index = row['Index'];
                const firstName = row['Ime'];
                const lastName = row['Prezime'];
                const gradeText = String(row['Ocjena'] || '').trim();

                if (!index || !firstName || !lastName || !gradeText) {
                    errors.push(
                        <FormattedMessage
                            id="professorInputGrades.missingRequiredFields"
                            defaultMessage="Red {row}: Nedostaje jedno od obaveznih polja (Index, Ime, Prezime, Ocjena)."
                            values={{ row: i + 2 }}
                        />
                    );
                    return;
                }

                const mark = this.getValidMarks().find(mark => mark.text.toLowerCase() === gradeText.toLowerCase()) ||
                    this.getValidMarks().find(mark => mark.text.toLowerCase().includes(gradeText.toLowerCase()));

                if (!mark) {
                    errors.push(
                        <FormattedMessage
                            id="professorInputGrades.invalidGrade"
                            defaultMessage='Red {row}: Ocjena "{grade}" nije validna.'
                            values={{ row: i + 2, grade: gradeText }}
                        />
                    );
                    return;
                }

                const student = this.getDataToRender().find(s =>
                    s.index == index &&
                    normalize(s.firstName) === normalize(firstName) &&
                    normalize(s.lastName) === normalize(lastName)
                );

                if (!student) {
                    errors.push(
                        <FormattedMessage
                            id="professorInputGrades.studentNotFound"
                            defaultMessage='Red {row}: Student "{firstName} {lastName}" s indexom "{index}" nije pronađen/a među neocijenjenim studentima.'
                            values={{ row: i + 2, firstName, lastName, index }}
                        />
                    );
                    return;
                }

                imported.push({
                    ...student,
                    grade: mark.text,
                });
            });

            const seenKeys = [];
            const uniqueImported = [];

            for (let i = imported.length - 1; i >= 0; i--) {
                const student = imported[i];
                const key = `${student.index}|${student.firstName.toLowerCase()}|${student.lastName.toLowerCase()}`;

                if (!seenKeys.includes(key)) {
                    seenKeys.push(key);
                    uniqueImported.unshift(student); // očuvaj originalni redoslijed
                }
            }
            // uniqueImported.push(...imported);

            uniqueImported.sort((a, b) => {
                const lnA = a.lastName.toLowerCase();
                const lnB = b.lastName.toLowerCase();
                if (lnA < lnB) return -1;
                if (lnA > lnB) return 1;

                const fnA = a.firstName.toLowerCase();
                const fnB = b.firstName.toLowerCase();
                if (fnA < fnB) return -1;
                if (fnA > fnB) return 1;

                return a.index.localeCompare(b.index, undefined, { numeric: true });
            });

            this.setState({
                importedData: uniqueImported,
                importErrors: errors,
                currentImportPage: 1,
            });
        };

        reader.readAsArrayBuffer(file);
    };

    getValidMarks = () => {
        return this.props.marks.filter(mark => mark.key_ !== 'nz' && mark.key_ !== 'no' && mark.key_ !== 'nonp' && mark.key_ !== 'f' && mark.key_ !== 'not_defended' && mark.key_ !== 'uo');
    };

    handleSubmitImportedGrades = async () => {
        this.setState({ submittingGrades: true });

        const submitCalls = this.state.importedData.map(student => {
            const gradeText = String(student.grade || "").trim();
            if (!gradeText) return null;

            const mark = this.getValidMarks().find(mark => mark.text.toLowerCase() === gradeText.toLowerCase()) ||
                this.getValidMarks().find(mark => mark.text.toLowerCase().includes(gradeText.toLowerCase()));

            if (!mark) return null;

            const gradeId = mark.key;
            const studentGradedActivityId = student.studentGradedActivityId;

            return axios.post(`professor/grade-student/${studentGradedActivityId}/${gradeId}`)
                .then(res => {
                    this.props.getStudentsForGroupGrading();
                    this.props.getAllStudents(localStorage.getItem('gradedActivityId'), false);
                    this.props.getAllStudents(localStorage.getItem('gradedActivityId'), true);
                })
                .catch(err => {
                    //console.error('Error submitting grade:', err);
                    this.props.getStudentsForGroupGrading();
                    this.props.getAllStudents(localStorage.getItem('gradedActivityId'), false);
                    this.props.getAllStudents(localStorage.getItem('gradedActivityId'), true);
                });
        }).filter(call => call !== null);

        try {
            await Promise.all(submitCalls);

            this.setState({
                importedData: [],
                importErrors: [],
                submittingGrades: false,
                showGradesMode: null,
                grading: false,
                rowLoader: false,
                importFilterGrade: '',
                importFilterStudyType: '',
                importFilterDepartmentId: '',
                importFilterStudyProgramBasicId: '',
                importedSearchResults: [],
            });

            this.resetFileInput();
            toast(<FormattedMessage id="professorInputGrades.toastGradeImportSuccess" />);
        } catch (error) {
            this.setState({ submittingGrades: false });
            toast(<FormattedMessage id="professorInputGrades.toastGradeImportFailed" />);
        }
    };

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    handleImportPaginationChange = (e, { activePage }) => this.setState({ activeImportPage: activePage })

    handleGradeChange({ value }, index) {
        this.setState({ grading: true, grade: value, showGradesMode: index });
    }

    cancel(index) {
        if (this.state.showGradesMode === index) {
            this.setState({ grading: false, showGradesMode: null, grade: 8 });
        }
    }


    confirmGrade(studentGradedActivityId, studentMarkId, markId, index, toast = true) {

        this.setState({
            importedData: [],
            importErrors: [],
            showGradesMode: index,
            grading: true,
            rowLoader: true,
            selectedData: this.state.selectedData.filter(el => el.studentGradedActivityId !== studentGradedActivityId),
            importFilterGrade: '',
            importFilterStudyType: '',
            importFilterDepartmentId: '',
            importFilterStudyProgramBasicId: '',
            importedSearchResults: [],
        })
        axios.post(`professor/grade-student/${studentGradedActivityId}/${markId}`)
            .then(res => {
                this.props.getStudentsForGroupGrading();
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), false);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), true);


            }).then(() => {
                if (toast)
                    toast(<FormattedMessage id="professorInputGrades.toastStudentGraded" />);
            })
            .catch(err => {
                //console.log('Pogrešno!');
                this.props.getStudentsForGroupGrading();
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), false);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), true);

                //this.setState({ grading: false, rowLoader: false, showGradesMode: null, grade: 8 });
                // toast(<FormattedMessage id="professorInputGrades.toastStudentGradedFailed" />);
            });
    }

    groupGrading() {
        this.setState({ loadGrading: true });
        let list = [];
        this.state.selectedData.map(el => list.push(el.studentGradedActivityId));

        axios.post(`professor/grade-student/${this.state.groupGrade}`, [...list])
            .then(res => {
                toast(<FormattedMessage id="professorInputGrades.toastStudentsGraded" />);
                this.props.getStudentsForGroupGrading();
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), false);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), true);
                this.setState({ grading: false, showGradesMode: null, grade: 8, groupGrade: '', selectedData: [], loadGrading: false });
            })
            .catch(err => {
                // console.log('Pogrešno!');
                toast(<FormattedMessage id="professorInputGrades.toastStudentsGraded" />);
                this.props.getStudentsForGroupGrading();
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), false);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), true);
                this.setState({ grading: false, showGradesMode: null, grade: 8, groupGrade: '', selectedData: [], loadGrading: false });
                // toast(<FormattedMessage id="professorInputGrades.toastStudentsGradedFailed" />);
            });
    }

    handleResultsPerPageChange(e, { value }) {
        if (value === 0) {
            localStorage.setItem('postsPerPageTab0', JSON.stringify(this.getDataToRender().length));
            this.setState({ activePage: 1, postsPerPage: this.getDataToRender().length });
        } else {
            localStorage.setItem('postsPerPageTab0', JSON.stringify(value));
            this.setState({ activePage: 1, postsPerPage: value });
        }

    }

    handleResultsPerPageChangeImport(e, { value }) {
        if (value === 0) {
            localStorage.setItem('postsPerPageTab2', JSON.stringify(this.state.importedData.length));
            this.setState({ activeImportPage: 1, importPostsPerPage: this.state.importedData.length });
        } else {
            localStorage.setItem('postsPerPageTab2', JSON.stringify(value));
            this.setState({ activeImportPage: 1, importPostsPerPage: value });
        }

    }

    selectAll() {
        const { selectedData } = this.state;
        // deselect all if data.length === selectedData.length
        if (selectedData.length === this.getDataToRender().length) {
            this.setState({ selectedData: [] });
        } else {
            this.setState({ selectedData: this.getDataToRender() });
        }
    }

    onSelectRow(studentGradedActivityId) {
        const row = this.getDataToRender().find(el => el.studentGradedActivityId === studentGradedActivityId);
        const pos = this.state.selectedData.findIndex(el => el.studentGradedActivityId === row.studentGradedActivityId);
        if (pos === -1) {
            // add to selectedData
            this.setState({ selectedData: [...this.state.selectedData, row] });
        } else {
            // remove from selectedData
            const newSelectedData = this.state.selectedData.filter(el => el.studentGradedActivityId !== row.studentGradedActivityId);
            this.setState({ selectedData: newSelectedData });
        }
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value });

    handleInputChange(e, { name, value }) {

        this.setState({ [name]: value, resetValue: true }, () => {
            let { departmentId, studyProgramBasicId, studyType, sortingOption } = this.state;
            this.setState({ filterDataMode: true });
            this.props.frontFilterData(this.props.data, departmentId, studyProgramBasicId, studyType ? studyType.id : null, sortingOption, false)
        });
    }

    getResults(results) {
        this.setState({ results, resetValue: false });
        this.handlePaginationChange({}, { activePage: 1 })
    }

    getImportedResults = (results) => {
        this.setState({
            importedSearchResults: results,
            activeImportPage: 1
        });
    };

    render() {

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const panes = [
            {
                menuItem: { content: <FormattedMessage id="professorInputGrades.individuallyGrading" /> },
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>

                        {(!this.state.showNoGradesFilterMode && this.getDataToRender().length > 0) && <ResultsPerPageDropdown
                            resultsPerPage={this.state.postsPerPage === this.getDataToRender().length ? 0 : this.state.postsPerPage}
                            onResultsPerPageChange={this.handleResultsPerPageChange}
                        />
                        }
                        <br />  <br />

                        {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :


                            <Table celled selectable>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={20}>
                                            {/*<div style={{ paddingLeft: '30px' }}>*/}
                                            <Grid columns={1}>
                                                <Grid.Column>
                                                    <SearchTableData profMozilla data={this.getDataToRender()} getResults={this.getResults} resetValue={this.state.resetValue} disabled={this.state.disabledFilter} filterItem={['index', 'firstName', 'lastName', 'name', 'studyProgramBasicName']} />
                                                </Grid.Column>
                                            </Grid>
                                            {/*</div>*/}
                                        </Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={20}>
                                            <Form>
                                                <Form.Group widths="equal">
                                                    <Form.Field
                                                        clearable
                                                        width={4}
                                                        required
                                                        control={Select}
                                                        placeholder="Odsjek"
                                                        value={this.state.departmentId}
                                                        name="departmentId"
                                                        options={this.props.departments}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    <Form.Field
                                                        clearable
                                                        width={4}
                                                        required
                                                        control={Select}
                                                        placeholder="Studijski program"
                                                        value={this.state.studyProgramBasicId}
                                                        name="studyProgramBasicId"
                                                        options={this.props.studyPrograms}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    <Form.Field
                                                        clearable
                                                        width={4}
                                                        required
                                                        control={Select}
                                                        placeholder="Tip studiranja"
                                                        value={this.state.studyType}
                                                        name="studyType"
                                                        options={this.props.studyTypes}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    <Form.Field
                                                        clearable
                                                        width={4}
                                                        required
                                                        control={Select}
                                                        placeholder="Sortiranje"
                                                        value={this.state.sortingOption}
                                                        name="sortingOption"
                                                        options={this.props.sortingOptions}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    {/*<Form.Field>*/}
                                                    {/*    <Button*/}
                                                    {/*        basic*/}
                                                    {/*        color={'blue'}*/}
                                                    {/*        onClick={()=>{*/}
                                                    {/*            this.setState({filterDataMode:true});*/}
                                                    {/*            this.props.frontFilterData(this.state.data, departmentId, studyProgramBasicId, studyType.id)*/}
                                                    {/*        }}*/}
                                                    {/*    >Filtriraj</Button>*/}
                                                    {/*</Form.Field>*/}

                                                </Form.Group>

                                            </Form>


                                        </Table.HeaderCell>
                                    </Table.Row>

                                    <Table.Row>
                                        <Table.HeaderCell>R. br.</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={3} >
                                            <FormattedMessage id="common.index" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell
                                            verticalAlign="middle"
                                            colSpan={3}
                                        >
                                            <FormattedMessage id="common.lastName" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={3} verticalAlign="middle">
                                            <FormattedMessage id="common.firstName" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={4}>
                                            <FormattedMessage id="professorInputGrades.studyProgram" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={3}><FormattedMessage id="common.grade" /></Table.HeaderCell>
                                        <Table.HeaderCell colSpan={3}></Table.HeaderCell>

                                    </Table.Row>
                                </Table.Header>
                                {currentPosts.length ?
                                    <Table.Body> {currentPosts.map((el, index) =>
                                    (<Table.Row key={el.studentGradedActivityId} style={HeaderCursor}>
                                        <Table.Cell verticalAlign="middle" >
                                            {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                        </Table.Cell>
                                        <Table.Cell
                                            colSpan={3}
                                            verticalAlign="middle"
                                        >
                                            <Grid columns={2} centered stackable>
                                                <Grid.Column width="10">
                                                    {el.index}
                                                </Grid.Column>
                                                <Grid.Column verticalAlign="middle" textAlign="right" width="6">
                                                    <span>
                                                        {<Popup content={el.studyType} hideOnScroll position="top center" trigger={<span style={{ color: '#a6a4a1' }}>
                                                            {el.studyType === 'redovan-samofinansirajući' && 'RSF'}
                                                            {el.studyType === 'redovan' && 'R'}
                                                            {el.studyType === 'vanredan' && 'V'}
                                                            {el.studyType === 'paralelan' && 'P'}
                                                            {el.studyType === 'DL studij' && 'DL'}

                                                        </span>} />}
                                                    </span>
                                                </Grid.Column>
                                            </Grid>



                                        </Table.Cell>

                                        <Popup content={<FormattedMessage id="professorInputGrades.showStudentInfo" />} hideOnScroll position="top center" trigger={
                                            <Table.Cell
                                                colSpan={3}
                                                verticalAlign="middle"
                                                onClick={() => this.setState({
                                                    studentId: el.studentId, sspId: el.studentStudyProgramId, studyProgramId: el.studyProgramId, showStudentInfo: true
                                                })}
                                            >
                                                {el.lastName}
                                            </Table.Cell>


                                        } />

                                        <Popup content={<FormattedMessage id="professorInputGrades.showStudentInfo" />} hideOnScroll position="top center" trigger={

                                            <Table.Cell
                                                colSpan={3}
                                                verticalAlign="middle"
                                                onClick={() => this.setState({
                                                    studentId: el.studentId, sspId: el.studentStudyProgramId, studyProgramId: el.studyProgramId, showStudentInfo: true
                                                })}
                                            >
                                                {el.firstName}
                                            </Table.Cell>


                                        } />

                                        <Table.Cell
                                            colSpan={4}
                                            verticalAlign="middle"
                                        >
                                            {

                                                el.departments ? el.departments.map(e => (<div>

                                                    {e.name === el.studyProgramBasicName ?
                                                        e.name
                                                        :

                                                        e.name && e.name !== '-' ?
                                                            //ima odsjek i nije crtica
                                                            <span>
                                                                <strong>{e.name}</strong> <span> {el.studyProgramBasicName && el.studyProgramBasicName !== '-' ? (' | ' + el.studyProgramBasicName) : ''}</span>
                                                            </span>
                                                            :
                                                            //nema odsjek ili je crtica
                                                            el.studyProgramBasicName ? el.studyProgramBasicName : ''

                                                    }
                                                </div>
                                                )) : el.studyProgramBasicName ? el.studyProgramBasicName : ''

                                            }
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" colSpan={3}>
                                            {
                                                <Form.Dropdown
                                                    disabled={this.state.grading && this.state.showGradesMode !== el.index}
                                                    placeholder={<FormattedMessage id="professorInputGrades.selectGrade" />}
                                                    value={this.state.showGradesMode !== el.index ? 8 : this.state.grade}
                                                    onChange={(e, event) => this.handleGradeChange(event, el.index)}
                                                    name="grade"
                                                    options={this.getValidMarks()}
                                                    search
                                                    fluid
                                                />}
                                        </Table.Cell>
                                        <Table.Cell textAlign="center" verticalAlign="middle" colSpan={3}>
                                            {
                                                <div>
                                                    <Popup
                                                        content={<FormattedMessage id="professorInputGrades.confirmGrade" />}
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                loading={this.state.rowLoader && this.state.showGradesMode === el.index}
                                                                disabled={(this.state.grading && this.state.showGradesMode !== el.index) || this.state.showGradesMode !== el.index}
                                                                basic="true"
                                                                circular
                                                                icon="check"
                                                                size="small"
                                                                color="green"
                                                                onClick={
                                                                    () => {
                                                                        this.confirmGrade(el.id, el.studentMarkId, this.state.grade, el.index);
                                                                    }
                                                                }
                                                            >
                                                            </Button>
                                                        }
                                                    />
                                                    <Popup
                                                        content={<FormattedMessage id="common.cancelO" />}
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                disabled={this.state.rowLoader || (this.state.grading && this.state.showGradesMode !== el.index) || this.state.showGradesMode !== el.index}
                                                                basic="true"
                                                                circular
                                                                icon="close"
                                                                size="small"
                                                                color="red"
                                                                onClick={() => this.cancel(el.index)}
                                                            >
                                                            </Button>
                                                        }
                                                    />
                                                </div>
                                            }
                                        </Table.Cell>
                                    </Table.Row>))}
                                    </Table.Body>
                                    : this.state.showFiltersOnButton ?
                                        <NoCurrentGradesFilterMessage />
                                        : <Table.Body>
                                            <Table.Row >
                                                <Table.Cell verticalAlign="middle" colSpan={10} ><NoCurrentGradesMessage /></Table.Cell></Table.Row></Table.Body>}
                            </Table>


                        }
                        {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                    </div>
                </Tab.Pane>)
            },
            {
                menuItem: { content: <FormattedMessage id="professorInputGrades.groupGrading" /> },
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>
                        {this.getDataToRender().length !== 0 && <Segment secondary textAlign='center' verticalAlign='middle'>
                            <Header style={IconHeader} floated="right">
                                <Popup
                                    trigger={<Icon circular basic="true" name="info" size='large' />}
                                    content={<p><FormattedMessage id="professorInputGrades.groupGradingInfo" /><b><i><FormattedMessage id="professorInputGrades.groupGradingInfo2" /></i></b><FormattedMessage id="professorInputGrades.groupGradingInfo3" /></p>}
                                    size="small"
                                    data-position="left center"
                                    wide
                                    position="top right"
                                />
                            </Header>
                            <br />

                            {this.state.loadGrading ?
                                <Loader active inline="centered" />
                                : <Form>
                                    <Form.Group widths='equal'>
                                        <Form.Field />
                                        <Form.Field>
                                            <Form.Dropdown
                                                placeholder={<FormattedMessage id="professorInputGrades.selectGrade" />}
                                                value={this.state.groupGrade}
                                                onChange={this.handleChange}
                                                name="groupGrade"
                                                options={this.getValidMarks()}
                                                search
                                                selection
                                                clearable
                                            />
                                        </Form.Field>
                                        <Button color='blue' disabled={!this.state.selectedData.length || !this.state.groupGrade} onClick={this.groupGrading}>
                                            <FormattedMessage id="professorInputGrades.grade" />
                                        </Button>
                                        <Button color='blue' basic='true' onClick={() => this.setState({ selectedData: [], groupGrade: '' })}>
                                            <FormattedMessage id="common.cancelO" />
                                        </Button>
                                        <Form.Field />

                                    </Form.Group>
                                </Form>}

                        </Segment>}

                        {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :
                            this.getDataToRender().length ?
                                <Table celled selectable compact>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell width={1} textAlign='center'>
                                                <Checkbox
                                                    type="checkbox"
                                                    name="checkAllButton"
                                                    value={this.state.selectedData.length === this.getDataToRender().length}
                                                    onChange={this.selectAll}
                                                    checked={this.state.selectedData.length === this.getDataToRender().length}
                                                />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell width={2}>
                                                <FormattedMessage id="common.index" />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                <FormattedMessage id="common.lastName" />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                <FormattedMessage id="common.firstName" />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell colSpan={2}>
                                                <FormattedMessage id="professorInputGrades.studyProgram" />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                <FormattedMessage id="professorInputGrades.studentStudyType" />
                                            </Table.HeaderCell>

                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body> {this.getDataToRender().map((el) =>
                                    (<Table.Row
                                        key={el.studentGradedActivityId}
                                        style={HeaderCursor}
                                        warning={this.state.selectedData.find(e => e.studentGradedActivityId === el.studentGradedActivityId)}
                                        onClick={() => this.onSelectRow(el.studentGradedActivityId)}
                                    >
                                        <Table.Cell
                                            verticalAlign="middle"
                                            textAlign="center"
                                        >
                                            <Checkbox
                                                name={el.studentGradedActivityId}
                                                type="checkbox"
                                                checked={this.state.selectedData.findIndex(e => e.studentGradedActivityId === el.studentGradedActivityId) > -1}
                                            />

                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" width={2}>
                                            {el.index}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.lastName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.firstName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" colSpan={2}>
                                            {

                                                el.departments ? el.departments.map(e => (<div>

                                                    {e.name === el.studyProgramBasicName ?
                                                        e.name
                                                        :

                                                        e.name && e.name !== '-' ?
                                                            //ima odsjek i nije crtica
                                                            <span>
                                                                <strong>{e.name}</strong> <span> {el.studyProgramBasicName && el.studyProgramBasicName !== '-' ? (' | ' + el.studyProgramBasicName) : ''}</span>
                                                            </span>
                                                            :
                                                            //nema odsjek ili je crtica
                                                            el.studyProgramBasicName ? el.studyProgramBasicName : ''

                                                    }
                                                </div>
                                                )) : el.studyProgramBasicName ? el.studyProgramBasicName : ''

                                            }
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.studyType}
                                        </Table.Cell>
                                    </Table.Row>
                                    ))}
                                    </Table.Body>
                                </Table>
                                : this.state.showFiltersOnButton ?
                                    <NoCurrentGradesFilterMessage />
                                    : <NoCurrentGradesMessage />

                        }
                    </div>
                </Tab.Pane>)
            },
            {
                menuItem: { content: <FormattedMessage id="professorInputGrades.importGrades" /> },
                render: () => {
                    const baseData = this.state.importedSearchResults.length > 0
                        ? this.state.importedSearchResults
                        : this.state.importedData;

                    const filteredImportedData = baseData.filter(student => {
                        console.log(this.state.importFilterName);
                        const typeMatch =
                            !this.state.importFilterStudyType ||
                            student.studyType === this.state.importFilterStudyType;

                        const selectedGradeKey = (() => {
                            if (!this.state.importFilterGrade) return null;

                            const mark = this.getValidMarks().find(mark =>
                                mark.text.toLowerCase() === this.state.importFilterGrade.toLowerCase()
                            ) || this.getValidMarks().find(mark =>
                                mark.text.toLowerCase().includes(this.state.importFilterGrade.toLowerCase())
                            );

                            return mark ? mark.key : null;
                        })();

                        const validMarks = this.getValidMarks();
                        const gradeMatch = !selectedGradeKey || (() => {
                            const studentGradeText = String(student.grade || "").trim().toLowerCase();

                            const matchedMark = validMarks.find(mark =>
                                mark.text.toLowerCase() === studentGradeText
                            ) || validMarks.find(mark =>
                                mark.text.toLowerCase().includes(studentGradeText)
                            );

                            return matchedMark && matchedMark.key === selectedGradeKey;
                        })();

                        const departmentMatch =
                            !this.state.importFilterDepartmentId ||
                            (student.departments &&
                                Array.isArray(student.departments) &&
                                student.departments.some(dep => dep.id === this.state.importFilterDepartmentId));

                        const studyProgramMatch =
                            !this.state.importFilterStudyProgramBasicId ||
                            student.studyProgramBasicId === this.state.importFilterStudyProgramBasicId;

                        return typeMatch && gradeMatch && departmentMatch && studyProgramMatch;
                    });

                    const indexOfLastPost = this.state.activeImportPage * this.state.importPostsPerPage;
                    const indexOfFirstPost = indexOfLastPost - this.state.importPostsPerPage;
                    const currentImportedPosts = filteredImportedData.slice(indexOfFirstPost, indexOfLastPost);

                    return (<Tab.Pane attached={false} as={Responsive}>
                        <div style={{ margin: '0 auto' }}>
                            <Segment secondary>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Popup
                                        trigger={<Icon circular basic name="info" size="small" />}
                                        content={
                                            <div>
                                                <p>
                                                    <FormattedMessage id="professorInputGrades.importInfo1" defaultMessage="Fajl koji odaberete mora imati sljedeće četiri kolone:" />
                                                    <br />
                                                    <b><FormattedMessage id="comon.index" defaultMessage="Index" /></b>,{' '}
                                                    <b><FormattedMessage id="common.firstName" defaultMessage="Ime" /></b>,{' '}
                                                    <b><FormattedMessage id="common.lastName" defaultMessage="Prezime" /></b>,{' '}
                                                    <b><FormattedMessage id="professorInputGrades.grade2" defaultMessage="Ocjena" /></b>.{' '}
                                                    <br />
                                                    <FormattedMessage id="professorInputGrades.orderNotImportant" defaultMessage="" />
                                                    <br />
                                                    <br />
                                                    <FormattedMessage id="professorInputGrades.importInfo2" defaultMessage="Također, ocjene moraju biti iz sljedećeg skupa:" />
                                                </p>
                                                <ul style={{ paddingLeft: '1.2em', marginTop: 0 }}>
                                                    {this.props.marks.filter(el => (el.key_ !== 'nz' && el.key_ !== 'no' && el.key_ !== 'nonp' && el.key_ !== 'f' && el.key_ !== 'not_defended' && el.key_ !== 'uo')).map(mark => (
                                                        <li key={mark.key}><b>{mark.text}</b></li>
                                                    ))}
                                                </ul>
                                                <FormattedMessage id="professorInputGrades.importInfo3" defaultMessage="If there are duplicate students (same index) in the Excel file, the grade from the later row will be used." />
                                            </div>
                                        }
                                        size="small"
                                        position="top right"
                                        wide
                                    />
                                </div>
                            </Segment>
                            <Segment padded>
                                <Header as="h4" textAlign="center">
                                    <FormattedMessage id="professorInputGrades.uploadExcel" />
                                </Header>
                                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1em' }}>
                                    <Button
                                        icon="upload"
                                        color='blue'
                                        basic='true'
                                        disabled={this.state.submittingGrades || this.state.importedData.length > 0}
                                        content={<FormattedMessage id="professorInputGrades.selectFile" defaultMessage="Select File" />}
                                        onClick={() => this.fileInputRef.click()}
                                    />
                                    <input
                                        ref={ref => this.fileInputRef = ref}
                                        style={{ display: 'none' }}
                                        type="file"
                                        accept=".xlsx, .xls"
                                        onChange={this.handleFileUpload}
                                    />
                                </div>
                                {this.state.importErrors.length > 0 && (
                                    <Message negative>
                                        <Message.Header>
                                            <FormattedMessage id="professorInputGrades.importErrors" defaultMessage="Import Errors" />
                                        </Message.Header>
                                        <Message.List>
                                            {(this.state.showAllErrors ? this.state.importErrors : this.state.importErrors.slice(0, 5)).map((err, i) => (
                                                <Message.Item key={i}>{err}</Message.Item>
                                            ))}
                                        </Message.List>
                                        {this.state.importErrors.length > 5 && (
                                            <div style={{ marginTop: '0.5em', textAlign: 'left' }}>
                                                <span
                                                    style={{ cursor: 'pointer', fontWeight: 'normal' }}
                                                    onClick={() => this.setState({ showAllErrors: !this.state.showAllErrors })}
                                                >
                                                    {this.state.showAllErrors ? (
                                                        <FormattedMessage id="errors.hideErrors" />
                                                    ) : (
                                                        <FormattedMessage
                                                            id="errors.showAllErrors"
                                                            values={{ count: this.state.importErrors.length }}
                                                        />
                                                    )}
                                                </span>
                                            </div>
                                        )}
                                    </Message>
                                )}
                            </Segment>

                            {Array.isArray(this.state.data) && this.state.importedData.length > 0 && (
                                <Segment padded >
                                    <ResultsPerPageDropdown
                                        resultsPerPage={this.state.importPostsPerPage}
                                        onResultsPerPageChange={this.handleResultsPerPageChangeImport}
                                    />
                                    <br />
                                    <br />
                                    <Table celled compact selectable>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell colSpan={13}>
                                                    <Grid columns={1}>
                                                        <Grid.Column>
                                                            <SearchTableData
                                                                profMozilla
                                                                data={this.state.importedData}
                                                                getResults={this.getImportedResults}
                                                                resetValue={this.state.resetValue}
                                                                disabled={this.state.disabledFilter}
                                                                filterItem={['index', 'firstName', 'lastName', 'studyProgramBasicName']}
                                                            />
                                                        </Grid.Column>
                                                    </Grid>
                                                </Table.HeaderCell>
                                            </Table.Row>

                                            <Table.Row>
                                                <Table.HeaderCell colSpan={13}>
                                                    <Form>
                                                        <Form.Group widths="equal">
                                                            <Form.Field
                                                                clearable
                                                                control={Select}
                                                                placeholder="Odsjek"
                                                                value={this.state.importFilterDepartmentId}
                                                                name="importFilterDepartmentId"
                                                                options={this.props.departments}
                                                                onChange={(e, { value }) => {
                                                                    this.setState({ importFilterDepartmentId: value, activeImportPage: 1 });
                                                                }}
                                                            />

                                                            <Form.Field
                                                                clearable
                                                                control={Select}
                                                                placeholder="Studijski program"
                                                                value={this.state.importFilterStudyProgramBasicId}
                                                                name="importFilterStudyProgramBasicId"
                                                                options={this.props.studyPrograms}
                                                                onChange={(e, { value }) => {
                                                                    this.setState({ importFilterStudyProgramBasicId: value, activeImportPage: 1 });
                                                                }}
                                                            />

                                                            <Form.Field
                                                                clearable
                                                                control={Select}
                                                                placeholder="Tip studija"
                                                                value={this.state.importFilterStudyType}
                                                                name="importFilterStudyType"
                                                                options={[
                                                                    { key: 'R', text: 'Redovan', value: 'redovan' },
                                                                    { key: 'RSF', text: 'Redovan samofinansirajući', value: 'redovan-samofinansirajući' },
                                                                    { key: 'V', text: 'Vanredan', value: 'vanredan' },
                                                                    { key: 'P', text: 'Paralelan', value: 'paralelan' },
                                                                    { key: 'DL', text: 'DL studij', value: 'DL studij' },
                                                                ]}
                                                                onChange={(e, { value }) => {
                                                                    this.setState({ importFilterStudyType: value, activeImportPage: 1 });
                                                                }}
                                                            />

                                                            <Form.Field
                                                                clearable
                                                                control={Select}
                                                                placeholder="Ocjena"
                                                                value={this.state.importFilterGrade}
                                                                name="importFilterGrade"
                                                                options={this.getValidMarks().map(m => ({
                                                                    key: m.key,
                                                                    text: m.text,
                                                                    value: m.text
                                                                }))}
                                                                onChange={(e, { value }) => {
                                                                    this.setState({ importFilterGrade: value, activeImportPage: 1 });
                                                                }}
                                                            />
                                                        </Form.Group>
                                                    </Form>
                                                </Table.HeaderCell>
                                            </Table.Row>

                                            <Table.Row>
                                                <Table.HeaderCell colSpan="1"><FormattedMessage id="common.ordinal" /></Table.HeaderCell>
                                                <Table.HeaderCell colSpan="2"><FormattedMessage id="common.index" /></Table.HeaderCell>
                                                <Table.HeaderCell colSpan="2"><FormattedMessage id="common.lastName" /></Table.HeaderCell>
                                                <Table.HeaderCell colSpan="2"><FormattedMessage id="common.firstName" /></Table.HeaderCell>
                                                <Table.HeaderCell colSpan="4"><FormattedMessage id="professorInputGrades.studyProgram" /></Table.HeaderCell>
                                                <Table.HeaderCell colSpan="2"><FormattedMessage id="professorInputGrades.grade2" /></Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {currentImportedPosts.length === 0 ? (
                                                <Table.Row>
                                                    <Table.Cell colSpan="13" textAlign="start">
                                                        <NoCurrentGradesMessage />
                                                    </Table.Cell>
                                                </Table.Row>
                                            ) :
                                                (
                                                    currentImportedPosts.map((student, idx) => (
                                                        <Table.Row key={idx}>
                                                            <Table.Cell verticalAlign="middle">
                                                                {idx + 1 + ((this.state.activeImportPage - 1) * this.state.importPostsPerPage)}.
                                                            </Table.Cell>
                                                            <Table.Cell colSpan="2" verticalAlign="middle">
                                                                <Grid columns={2} centered stackable>
                                                                    <Grid.Column width={10}>
                                                                        {student.index}
                                                                    </Grid.Column>
                                                                    <Grid.Column verticalAlign="middle" textAlign="right" width={6}>
                                                                        <span>
                                                                            <Popup
                                                                                content={student.studyType}
                                                                                hideOnScroll
                                                                                position="top center"
                                                                                trigger={
                                                                                    <span style={{ color: '#a6a4a1' }}>
                                                                                        {student.studyType === 'redovan-samofinansirajući' && 'RSF'}
                                                                                        {student.studyType === 'redovan' && 'R'}
                                                                                        {student.studyType === 'vanredan' && 'V'}
                                                                                        {student.studyType === 'paralelan' && 'P'}
                                                                                        {student.studyType === 'DL studij' && 'DL'}
                                                                                    </span>
                                                                                }
                                                                            />
                                                                        </span>
                                                                    </Grid.Column>
                                                                </Grid>
                                                            </Table.Cell>
                                                            <Table.Cell colSpan="2">{student.lastName}</Table.Cell>
                                                            <Table.Cell colSpan="2">{student.firstName}</Table.Cell>
                                                            <Table.Cell colSpan="4">
                                                                {student.departments ? student.departments.map((e, i) => (
                                                                    <div key={i}>
                                                                        {e.name === student.studyProgramBasicName ? (
                                                                            e.name
                                                                        ) : e.name && e.name !== '-' ? (
                                                                            <span>
                                                                                <strong>{e.name}</strong>
                                                                                <span>{student.studyProgramBasicName && student.studyProgramBasicName !== '-' ? (' | ' + student.studyProgramBasicName) : ''}</span>
                                                                            </span>
                                                                        ) : (
                                                                            student.studyProgramBasicName ? student.studyProgramBasicName : ''
                                                                        )}
                                                                    </div>
                                                                )) : student.studyProgramBasicName ? student.studyProgramBasicName : ''}
                                                            </Table.Cell>

                                                            <Table.Cell colSpan="2">{student.grade}</Table.Cell>
                                                        </Table.Row>
                                                    ))
                                                )}
                                        </Table.Body>
                                    </Table>

                                    <PaginationFront
                                        postsPerPage={this.state.importPostsPerPage}
                                        totalPosts={filteredImportedData.length}
                                        paginate={this.handleImportPaginationChange}
                                        activePage={this.state.activeImportPage}
                                    />
                                </Segment>
                            )}

                            <div style={{ textAlign: 'center', marginTop: '1.5em' }}>

                                {(this.state.importedData.length > 0) && (
                                    <Button
                                        color="green"
                                        basic
                                        onClick={this.handleSubmitImportedGrades}
                                        loading={this.state.submittingGrades}
                                    >
                                        <FormattedMessage id="professorInputGrades.submitImportedGrades" defaultMessage="Submit Grades" />
                                    </Button>
                                )}

                                {(this.state.importedData.length > 0 || this.state.importErrors.length > 0) && (
                                    <Button
                                        style={{ marginLeft: '1em' }}
                                        disabled={this.state.submittingGrades}
                                        basic
                                        color="red"
                                        onClick={() => {
                                            this.setState({
                                                importedData: [],
                                                importErrors: [],
                                                activeImportPage: 1,
                                                showAllErrors: false,
                                                importFilterGrade: '',
                                                importFilterStudyType: '',
                                                importFilterDepartmentId: '',
                                                importFilterStudyProgramBasicId: '',
                                                importedSearchResults: [],
                                            });
                                            this.resetFileInput();
                                        }}
                                    >
                                        <FormattedMessage id="common.clear" defaultMessage="Clear" />
                                    </Button>
                                )}

                            </div>
                        </div>
                    </Tab.Pane>)
                }
            }

        ];
        if (this.state.showStudentInfo === true) {
            return (
                <FormattedMessage id="route.studentGradesAndInfo">
                    {(msg) => (<Redirect push to={{ pathname: msg, state: { studentId: this.state.studentId, sspId: this.state.sspId, studyProgramId: this.state.studyProgramId } }} />)}
                </FormattedMessage>);
        }
        return (
            <div>
                <Tab
                    id="myTab"
                    panes={panes}
                    menu={{
                        secondary: true, pointing: true, color: 'blue', vertical: true, fluid: true, attached: true, tabular: true
                    }}
                    grid={{ paneWidth: 14, tabWidth: 2 }}
                    activeIndex={this.state.activeIndex}
                    onTabChange={this.handleTabChange}
                />

            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorInputGrades/StudentsWithoutGrades.js